import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const TransactionDataPropsSchema = z.object({
  transactionDataValue: z.instanceof(HexNumber),
})

type TransactionDataProps = z.infer<typeof TransactionDataPropsSchema>

export class TransactionData extends ValueObject<TransactionDataProps> {
  public getValue(): HexNumber {
    return this.props.transactionDataValue
  }

  /**
   * @returns A 0x-prefixed hex string.
   */
  public getHexValue(): string {
    return this.props.transactionDataValue.getValue()
  }

  public static create(transactionDataValue: HexNumber): TransactionData {
    const validatedProps = TransactionDataPropsSchema.parse({
      transactionDataValue,
    })
    return new TransactionData(validatedProps)
  }
}
